/**
 * Who may change a ticket's primary assignee, as far as the UI can tell.
 * Mirrors ticket-service's assignment-permissions, which has the final say:
 *
 *  - owners, admins and supervisors may assign, reassign and unassign;
 *  - everyone else (agents, light agents) may only give an UNASSIGNED ticket
 *    an assignee. Once a ticket has one, they can add secondary agents but not
 *    clear or replace the assignee.
 */
export const ASSIGNEE_MANAGER_ROLES = ['owner', 'admin', 'supervisor'] as const;

export const ASSIGNEE_LOCKED_HINT = 'Only an admin or supervisor can change or remove the assignee';

type RoleHolder = { role?: string | null } | null | undefined;

/** True for owners, admins and supervisors: they may change any assignee. */
export function canManageAssignees(user: RoleHolder): boolean {
  const role = (user?.role ?? '').trim().toLowerCase();
  return (ASSIGNEE_MANAGER_ROLES as readonly string[]).includes(role);
}

/** May this user clear or replace the assignee of a ticket currently assigned to `currentAssigneeId`? */
export function canChangeAssignee(user: RoleHolder, currentAssigneeId: string | null | undefined): boolean {
  return !currentAssigneeId || canManageAssignees(user);
}
